// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3JN06","choiceBoxes":"toolbarselects_choiceBoxes__2Km7g","simpleField":"toolbarselects_simpleField__27d5A"};